<script setup lang="ts">
import { onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

const router = useRouter()
const route = useRoute()
const authStore = useAuthStore()

onMounted(async () => {
  const token = route.query.token as string
  const error = route.query.error as string
  
  if (error) {
    console.error('Auth error:', error)
    router.push('/login?error=' + encodeURIComponent(error))
    return
  }
  
  if (token) {
    authStore.setToken(token)
    await authStore.fetchUser()
    router.push('/dashboard')
  } else {
    router.push('/login')
  }
})
</script>

<template>
  <div class="callback-view">
    <div class="callback-content">
      <el-icon class="loading-icon" :size="48">
        <svg class="spinner" viewBox="0 0 24 24">
          <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" fill="none" stroke-dasharray="32" stroke-dashoffset="32">
            <animate attributeName="stroke-dashoffset" dur="1s" repeatCount="indefinite" values="32;0"/>
          </circle>
        </svg>
      </el-icon>
      <p>Connexion en cours...</p>
    </div>
  </div>
</template>

<style scoped>
.callback-view {
  min-height: calc(100vh - 64px);
  display: flex;
  align-items: center;
  justify-content: center;
}

.callback-content {
  text-align: center;
}

.loading-icon {
  color: var(--m2v-primary);
  margin-bottom: var(--m2v-space-4);
}

.spinner {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

p {
  color: var(--m2v-text-muted);
}
</style>
